import React from "react";

import Input from "../../controls/Input";
import type { RecipeLineItem } from "../../../features/recipes/recipeTypes";

interface RecipeLineItemsTableProps {
  askDeleteRecipe: (item: RecipeLineItem, type: number) => void;
  items: RecipeLineItem[];
  openUpdateIngredientQuantity: (item: RecipeLineItem, index: number) => void;
  title: string;
  deleteType: number;
}

export default function RecipeLineItemsTable({
  askDeleteRecipe,
  items,
  openUpdateIngredientQuantity,
  title,
  deleteType,
}: RecipeLineItemsTableProps) {
  return (
    <div className="flex min-h-0 flex-1 flex-col px-1 py-2">
      <h3 className="text-base font-semibold leading-6 text-gray-900">
        {title}
      </h3>
      <div className="relative mt-2 flex-1 overflow-x-auto">
        <div className="card-custom overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-300">
            <thead className="bg-white">
              <tr>
                <th
                  scope="col"
                  className="py-3 pl-3 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6"
                >
                  Plu
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  Name
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  Quantity
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  Unit of measure
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                >
                  Recipe/kg
                </th>
                <th
                  scope="col"
                  className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                ></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200 bg-white">
              {items.map((item, index) => (
                <tr key={item.id} className="cursor-pointer">
                  <td className="whitespace-nowrap py-35-custom pl-4 pr-3 text-sm font-medium text-gray-500 sm:pl-6">
                    {item.bom_plu}
                  </td>
                  <td className="whitespace-nowrap px-3 py-35-custom text-sm text-gray-500">
                    {item.bom_name}
                  </td>
                  <td
                    className="whitespace-nowrap px-3 py-35-custom text-sm text-gray-500"
                    onClick={() => openUpdateIngredientQuantity(item, index)}
                  >
                    <div className="block w-20 rounded-md border border-gray-300 bg-gray-50 px-3 py-35-custom shadow-sm sm:text-sm">
                      <p className="mt-1.5">{item.quantity}</p>
                    </div>
                  </td>
                  <td className="whitespace-nowrap px-3 py-35-custom text-sm text-gray-500">
                    <div className="block w-20 rounded-md border border-gray-300 bg-gray-50 px-3 py-35-custom shadow-sm sm:text-sm">
                      <p className="mt-1.5">{item.unit_of_measure_label}</p>
                    </div>
                  </td>
                  <td className="whitespace-nowrap px-3 py-35-custom text-sm text-gray-500">
                    <Input
                      value={item.recipe_per_kg}
                      labelOn={false}
                      disabled={true}
                      type="text"
                      className="block w-24 rounded-md border border-gray-300 px-3 py-35-custom shadow-sm focus:border-sky-500 focus:outline-none focus:ring-sky-500 sm:text-sm"
                    />
                  </td>
                  <td className="relative whitespace-nowrap py-1.5 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                    <button
                      type="button"
                      onClick={() => askDeleteRecipe(item, deleteType)}
                      className="ml-2 rounded-md bg-red-600 px-3 py-35-custom text-sm font-semibold text-white shadow-sm hover:bg-red-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-red-600"
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
